import { z } from '@harvestiq/zod';
import { faqSchema } from './faq';
import { getFaqByIdParamsSchema } from './get-faq-by-id-schema';

export const getFaqByIdResponseSchema = z.object({
  success: z.boolean(),
  faq: faqSchema.nullable(),
});

export type GetFaqByIdResponse = z.infer<typeof getFaqByIdResponseSchema>;

export { getFaqByIdParamsSchema };
export type { GetFaqByIdSchemaParams } from './get-faq-by-id-schema';
